import React, { useState } from 'react';
import { ClassicSpinner } from '../../components/UI/Loader/ClassicSpinner';
import classes from './CountryListStyle.css';

export const CountriesList = ({ id, name, onClick, imgSrc, onLoad }) => {
    const [isLoading, setIsLoading] = useState(true);
    const [hasError, setHasError] = useState(false);

    return (
        <div className={classes.Card} data-id={id} onClick={onClick}>
            <div style={{ display: isLoading ? 'none' : 'block' }}>
                <img 
                    className={classes.CardImg} alt={name} src={imgSrc}
                    onLoad={() => {
                        setIsLoading(false);
                        onLoad();
                    }} 
                    onError={() => {
                        setHasError(true);
                        onLoad();
                    }}
                />
                <p className={classes.CountryName}>{name.toUpperCase()}</p>
            </div>
            {hasError && <p style={{ textAlign: 'center', margin: 0 }} className={classes.LoadingContainer}>{name}</p>}
            {isLoading && !hasError &&
                <div className={classes.LoadingContainer}>
                    <ClassicSpinner />
                </div>}
        </div>
    );
}


// WEBPACK FOOTER //
// ./src/containers/StoreList/CountriesList.js